<template>
  <Modal ref="modal" title="Agendadas Hoje" @cancel="close">
    <form class="export-container" @submit.prevent="handleSubmit">
      <Button type="submit" text="Fazer download" color="primary" :disabled="loading">
        <TrayArrowDown :size="18" />
      </Button>
    </form>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import Button from 'core/Button'
import TrayArrowDown from 'icons/TrayArrowDown'
import _export from '../../../../services/export'

export default {
  name: 'TeoricasAgendadasHojeModal',
  components: {
    Modal,
    Button,
    TrayArrowDown,
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()

      this.loading = false
    },
    async handleSubmit() {
      this.loading = true

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/export/planilha/turmas-teoricas/agendadas-hoje`)
        .then((res) => {
          _export.downloadCSV(res.body.dados, 'teoricas-agendadas-hoje')
        })
        .catch((err) => {
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  }
}
</script>

<style lang="scss" scoped>
.loading {
  width: 30vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export-container {
  min-width: 30vw;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  button {
    justify-content: center;
  }
}
</style>